import axios from 'axios'




const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://api.ki.schuberth.com';
//const API_BASE_URL = "http://localhost:8010";
const COCKPIT_BASE_URL = process.env.VUE_APP_COCKPIT_BASE_URL;
const COCKPIT_TOKEN = process.env.VUE_APP_COCKPIT_TOKEN;


const COLLECTION_NAME = 'chatbot_feedback';

// Cockpit CMS API Service
const cockpitAPI = axios.create({
  baseURL: COCKPIT_BASE_URL,
  headers: {
    'Authorization': `Bearer ${COCKPIT_TOKEN}`,
    'Content-Type': 'application/json'
  }
});


const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000,

})

// Request Interceptor für Logging
api.interceptors.request.use(
  (config) => {
    //console.log('API Request:', config.method?.toUpperCase(), config.url, config.data)
    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

export const chatAPI = {




// In api.js - nach submitFeedbackToCockpit

async submitQAToCockpit(question, answer, source = 'chat', session_id = null, language = 'de') {
  try {
    // HTML-Tags und Entities in Plain Text umwandeln
    const stripHtml = (html) => {
      if (!html) return '';
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.body.textContent || '';
    };

    const response = await fetch(`${COCKPIT_BASE_URL}/collections/save/list_chatbot_requests`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${COCKPIT_TOKEN}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          question: question,
          answer: stripHtml(answer),
          date: new Date().toISOString().slice(0, 10),
          source: source,
          session_id: session_id,
          language: language,
          timestamp: new Date().toISOString(),
          collection_name: 'list_chatbot_requests'
        }
      })
    });

    if (!response.ok) {
      throw new Error(`Cockpit error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    // Logging-Fehler soll den Chat nicht blockieren
    console.error('Cockpit QA logging error:', error);
  }
},


async getFAQsFromCockpit(lang = 'de') {
    try {
      // Validiere und mappe Sprachen falls nötig
      const validLanguages = ['de', 'en', 'fr', 'it', 'es', 'pt', 'pl'];
      const requestLang = validLanguages.includes(lang) ? lang : 'de';
      
      //console.log(`🌐 Lade FAQs für Sprache: ${requestLang}`);

      const response = await fetch(
        `${COCKPIT_BASE_URL}/collections/get/faqs?lang=${requestLang}`,
        {
          method: 'GET',
          headers: {
            'Cockpit-Token': COCKPIT_TOKEN, 
            'Content-Type': 'application/json'
          }
        }
      )

      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`)
      }

      const data = await response.json();
      //console.log(`✅ ${data.entries?.length || 0} FAQs für ${requestLang} erhalten`);
      return data;
      
    } catch (error) {
      console.error('Fehler beim Abrufen der FAQs:', error)
      throw error
    }
  },





  async submitFeedbackToCockpit(feedbackData) {
    try {
      const payload = {
        data: {
          session_id: feedbackData.session_id || 'default',
          query: feedbackData.query || 'Gesamtbewertung Chatbot',
          answer: feedbackData.answer || 'Allgemeine Chatbot-Erfahrung',
          rating: feedbackData.rating,
          issues: feedbackData.issues || [],
          feedback_text: feedbackData.feedback_text || '',
          source: feedbackData.source || 'chat',
          language: feedbackData.language || 'de',
          timestamp: new Date().toISOString()
        }
      };

      const response = await cockpitAPI.post(`/collections/save/${COLLECTION_NAME}`, payload);
      return response.data;
    } catch (error) {
      console.error('Cockpit feedback error:', error);
      throw error;
    }
  },
 
  async sendMessage(message, top_k = 5, session_id = null, topic = null, user_lang) {
    const safe_top_k = parseInt(top_k, 10)
    const safe_session_id = session_id ? String(session_id) : null
    if (isNaN(safe_top_k)) {
      console.warn('sendMessage: top_k war keine Zahl oder ungültig. Verwende Standardwert 5.')
    }
    try {
      const response = await api.post('/ask', {
        query: message,
        top_k: safe_top_k || 5,
        session_id: safe_session_id,
        topic: topic, 
        user_lang: user_lang 
      })
      const responseData = response.data
      return {
        response: responseData.answer || responseData.response,
        sources: responseData.sources || []
      }
    } catch (error) {
      if (error.response?.status === 422) {
        throw new Error('API-Datenfehler (422): Die gesendete Datenstruktur ist falsch.')
      }
      throw new Error(error.response?.data?.detail || 'Chat request failed')
    }
  },

 
 async uploadFilesAxios(files, onProgress = null) {
  const formData = new FormData();


  files.forEach(file => {
    formData.append('files', file);
  });

  try {
    const response = await api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percentCompleted);
        }
      }
    });
    return response.data;
  } catch (error) {
    console.error('Upload error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.detail || 'Upload failed');
  }
},

  uploadFiles: async (files, onProgress = null) => chatAPI.uploadFilesAxios(files, onProgress),

  /**
   * Systemstatus abfragen
   */
  async getStatus() {
    try {
      const response = await api.get('/status')
      return response.data
    } catch (error) {
      throw new Error('Status check failed')
    }
  },

  async submitFeedback(feedbackData) {
    try {
      const response = await axios.post(`${process.env.API_BASE_URL}/feedback`, feedbackData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Feedback API Error:', error);
      throw new Error(error.response?.data?.detail || 'Feedback konnte nicht gesendet werden');
    }
  },

  /**
   * Holt Feedback-Statistiken
   */
  async getFeedbackStats() {
    try {
      const response = await api.get('/feedback/stats')
      return response.data
    } catch (error) {
      throw new Error('Failed to fetch feedback stats')
    }
  }
}

export default api